// @flow

import styled from '@emotion/styled'
import { Link } from 'gatsby'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import { Logo } from '../logos'
import * as text from '../text'

type JobType = {
  title: string,
  category: string,
  location: string,
  team: 'global' | 'track' | 'hire' | 'plan',
  slug: string,
  ...
}

type Props = {
  jobs: $ReadOnlyArray<JobType>,
}
export const ThreeCol = ({ jobs }: Props) => {
  return (
    <Root>
      {jobs.map((vacancy, id) => (
        <VacancyWrapper to={`/jobs/${vacancy.slug}/`} key={id}>
          <text.P1 color={colors.darkPurple100}>{vacancy.title}</text.P1>
          <JobInfoWrapper>
            <JobMiniInfo>
              <img
                src={require('./assets/icon-team.svg').default}
                alt='Icon of 2 people. For category'
              />
              {vacancy.category}
            </JobMiniInfo>

            <JobMiniInfo>
              <img
                src={require('./assets/icon-location.svg').default}
                alt='Icon of a location marker'
              />
              {vacancy.location}
            </JobMiniInfo>
            <TeamStyled>
              <Logo kind={vacancy.team} />
            </TeamStyled>
          </JobInfoWrapper>
        </VacancyWrapper>
      ))}
    </Root>
  )
}

const TeamStyled: React.ComponentType<any> = styled.div`
  display: none;
  svg {
    height: 24px;
    fill: ${colors.darkPurple100};
  }
  ${media.mq[1]} {
    display: block;
    margin-left: auto;
  }
`

const JobInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  color: ${colors.darkPurple80};
  ${media.mq[1]} {
    flex-direction: row;
    align-items: flex-end;
    gap: 20px;
  }
`

const VacancyWrapper: React.ComponentType<any> = styled(Link)`
  display: flex;
  border-radius: 8px;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  margin: 10px 0;
  background: ${colors.peach100};
  color: ${colors.darkPurple90};
  ${media.mq[1]} {
    margin: 15px 0;
    padding: 25px;
    gap: 2px;
    &:hover {
      background: ${colors.yellow100};
    }
  }
`

const Root: React.ComponentType<any> = styled.div`
  margin: 20px auto 0;
`

const JobMiniInfo = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  img {
    height: 18px;
    width: 18px;
    object-fit: contain;
  }
`
